export class CrfQuestionsRequest {
    "sectionId": Number;
    "userId": Number;
}